/**
 * Linear Assets — Corridor Health & Regulatory Reports
 */

import React, { useState } from 'react';
import { FileText, Download, Shield, Calendar, RefreshCw } from 'lucide-react';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import { reportsApi } from '../../services/api';

export const LinearReportsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
            <FileText className="w-7 h-7 text-amber-500" /> Linear Corridor Compliance Reports
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Certified compliance audits, right-of-way clearance certificates, and annual vegetation management reports
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card className="p-5 space-y-3">
          <h3 className="font-bold text-sm text-gray-900 dark:text-white">Annual Corridor Clearance Audit (2026)</h3>
          <p className="text-xs text-gray-500">
            Comprehensive audit covering 845 km of transmission and rail corridors, including LiDAR clearance compliance and emergency track interventions.
          </p>
          <Button
            variant="primary"
            size="sm"
            onClick={() => reportsApi.downloadCertifiedPdf('carbon_credit', 'lin-cor-01')}
            className="flex items-center gap-1.5"
          >
            <Download className="w-4 h-4" /> Download Certified Audit PDF
          </Button>
        </Card>

        <Card className="p-5 space-y-3">
          <h3 className="font-bold text-sm text-gray-900 dark:text-white">Railway Track Safety &amp; Obstruction Ledger</h3>
          <p className="text-xs text-gray-500">
            Immutable log of near-real-time optical/thermal track inspections, response times (&lt; 2.5h avg), and rail buckling risk mitigation.
          </p>
          <Button
            variant="outline"
            size="sm"
            onClick={() => reportsApi.downloadCertifiedPdf('mission_summary', 'lin-cor-02')}
            className="flex items-center gap-1.5"
          >
            <Download className="w-4 h-4" /> Download Obstruction Ledger PDF
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default LinearReportsPage;
